/**
 * Environment configuration.
 *
 * Values come from the .env files and are baked into the bundle at build time
 * by Create React App, which only exposes names starting with REACT_APP_:
 *
 *   .env.development        npm start / npm run dev
 *   .env.production         npm run build
 *   .env.test               npm test
 *   .env.*.local            personal overrides, gitignored
 */

// A trailing slash would produce "//api/..." once a path is appended.
const configuredApiUrl = (process.env.REACT_APP_API_URL || "")
  .trim()
  .replace(/\/+$/, "");

/**
 * Backend base URL. An empty value means "same origin", which in development
 * is the CRA dev server proxying /api to the local mock (package.json
 * "proxy") — so 127.0.0.1 and LAN addresses behave exactly like localhost.
 */
export const API_URL = configuredApiUrl;

/** Absolute URL for an API path; stays relative while API_URL is empty. */
export function apiUrl(path) {
  return `${API_URL}${path.startsWith("/") ? path : `/${path}`}`;
}

if (process.env.NODE_ENV === "development" && API_URL) {
  // Loud on purpose: a remote backend creates real users, test results and
  // Monobank invoices from the dev server.
  console.warn(
    `[config] REACT_APP_API_URL=${API_URL} — talking to a remote backend, not the local mock.`,
  );
}
